
import { Box, Button, Paper } from "@mui/material"
import { useState } from "react";
import { iconos } from "../../../data";





export const BotonesGroup = ({ botonesOpciones }) => {

    
    const [active, setActive] = useState('');


    return (

        <Paper elevation={4} sx={{width:'100%', maxWidth:'100%', mb:2, px:0, overflow:'hidden', borderRadius:2}}>
            <Box className='.scroll-thin' sx={{  display:'flex',  flexWrap:'nowrap',  gap:1,  overflowX:'auto', 
                overflowY:'hidden',  whiteSpace:'nowrap', px:1, py:1, justifyContent:'center',
                '&::-webkit-scrollbar': { height:4 },  
            }}>

                {botonesOpciones.map((opcion) => {
                const isActivo = active === opcion.label;
                const isDisabled = opcion.disabled;

                return (
                    <Button key={opcion.label} disabled={isDisabled}
                        variant={isActivo ? 'contained' : 'outlined'}
                        startIcon={iconos[opcion.icono]}
                        onClick={() => { opcion.onClick?.(); setActive(opcion.label); }} 
                        sx={{ 
                            textTransform:'none', 
                            fontSize:13, 
                            fontWeight:500, 
                            borderRadius:1.5, 
                            flexShrink:0, 
                            px:1,
                            ...(isDisabled ? {
                            bgcolor:'grey.300',  
                            color:'grey.600',
                            borderColor:'grey.300',
                            '&.Mui-disabled': {
                                bgcolor:'grey.300',  
                                color:'grey.600',
                                borderColor:'grey.300',
                            }
                            } : {
                            borderColor: isActivo ? 'primary.main' : 'primary.light',
                            color: isActivo ? 'white' : 'primary.main',
                            bgcolor: isActivo ? 'primary.main' : 'transparent',
                            '&:hover': {
                                bgcolor: 'primary.dark', 
                                borderColor: 'primary.dark', 
                                color: 'white'
                            },
                            })
                    }}>

                        {opcion.label}

                    </Button>
                );})}
            </Box>
        </Paper>
    )
}
